<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원통계</span>
            <span class="txt">직원의 매출성과를 그래프로 볼 수 있는 통계입니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-check">
                    <input
                        id="select-check-1-1"
                        v-model="sign"
                        name="select-check-1"
                        type="checkbox"
                        value="I"
                        @change="onStaffStat"
                    />
                    <label for="select-check-1-1">근무중인 직원</label>
                </div>
                <div class="com-check">
                    <input
                        id="select-check-1-2"
                        v-model="resign"
                        name="select-check-1"
                        type="checkbox"
                        value="O"
                        @change="onStaffStat"
                    />
                    <label for="select-check-1-2">퇴사한 직원</label>
                </div>
                <select-form
                    :select-data="[...yearList]"
                    :select-value="[...yearValueList]"
                    :selected-value="yearDate"
                    class="w130"
                    @update:set="(val) => (yearDate = val)"
                ></select-form>
                <select-form
                    :select-data="[...monthList]"
                    :select-value="[...monthValueList]"
                    :selected-value="startDate"
                    class="w100"
                    @update:set="(val) => (startDate = val)"
                ></select-form>
                <div class="com-dash"><span class="dash">~</span></div>
                <select-form
                    :select-data="[...monthList]"
                    :select-value="[...monthValueList]"
                    :selected-value="endDate"
                    class="w100"
                    @update:set="(val) => (endDate = val)"
                ></select-form>
            </div>
        </div>

        <div class="graph-content">
            <div class="graph-area">
                <!-- <div class="half">
                    <span class="title">김윤경 매출현황</span>
                    <div class="graph-box" style="height: 500px;">
                        <apexchart type="line" height="500" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">김하연 매출현황</span>
                    <div class="graph-box" style="height: 500px;">
                        <apexchart type="line" height="500" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div>
            </div>
            <div class="graph-area">
                <div class="half">
                    <span class="title">강미미 매출현황</span>
                    <div class="graph-box" style="height: 500px;">
                        <apexchart type="line" height="500" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div>
                <div class="half">
                    <span class="title">김하연 매출현황</span>
                    <div class="graph-box" style="height: 500px;">
                        <apexchart type="line" height="500" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div> -->
                <div v-for="(s, index) in checkStaff" :key="index" class="half">
                    <span class="title">{{ checkStaff[index] }}</span>
                    <!-- 그래프 영역 -->
                    <div class="graph-box" style="height: 500px">
                        <apexchart :options="chartOptions" :series="series[index]" height="500" type="line"></apexchart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'StatsSale',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        startDate: function () {
            this.init();
        },
        endDate: function () {
            this.init();
        },
    },
    data() {
        return {
            centerId: '',
            chartOptions: { chart: { id: 'vuechart-example' }, xaxis: { categories: [] }, markers: { size: [6] } },
            series: [],
            checkStaff: [],
            yearList: [],
            yearValueList: [],
            monthList: [],
            monthValueList: [],
            startDate: moment().format('MM'), //moment().add(-1,'M').format('MM'),
            endDate: moment().format('MM'),
            yearDate: moment().format('YYYY'),
            status: 'T',
            sign: true,
            resign: true,
        };
    },
    created() {
        this.createDate();
    },
    mounted() {
        this.centerId = this.cId; //센터id
        this.init();
    },
    methods: {
        createDate() {
            //년도 자동생성
            for (let i = 0; i < 6; i++) {
                this.yearList.push(moment().subtract(i, 'y').format('YYYY년'));
                this.yearValueList.push(moment().subtract(i, 'y').format('YYYY'));
            }
            //월 자동생성
            for (let j = 1; j < 13; j++) {
                this.monthList.push(j + '월');
                this.monthValueList.push(('00' + j).slice(-2));
            }
        },
        async init() {
            try {
                await this.onStaffStat();
            } catch (error) {
                console.log(error);
                console.log('초기화에 실패하였습니다.');
            }
        },

        //직원 통계 조회
        async onStaffStat() {
            try {
                this.status = this.signStatus();
                console.log(this.status);

                const { data } = await this.getStaffStat();
                console.log('통계데이터', data);
                let xaxis = [];
                let price_array = []; //신규
                let price_array1 = []; //재등록
                let price_array2 = []; //전체
                data.forEach((g, index) => {
                    if (xaxis.includes(g.csbb_bill_year_month) != true) {
                        xaxis.push(g.csbb_bill_year_month);
                    }
                    if (this.checkStaff.includes(g.csbb_center_staff_nm) != true) {
                        this.checkStaff.push(g.csbb_center_staff_nm);
                        price_array = [];
                        price_array1 = [];
                        price_array2 = []; //초기화
                    }
                    price_array.push(g.csbb_sale_new_price); //신규
                    price_array1.push(g.csbb_sale_renew_price); //재등록
                    price_array2.push(g.csbb_total_sale_price); //전체
                    this.series[index] = [
                        { name: '신규', data: price_array },
                        { name: '재등록', data: price_array1 },
                        {
                            name: '전체',
                            data: price_array2,
                        },
                    ];
                    this.chartOptions = {
                        chart: {
                            id: 'vuechart-example',
                            toolbar: {
                                show: true,
                                tools: {
                                    download: true,
                                    selection: false,
                                    zoom: false,
                                    zoomin: false,
                                    zoomout: false,
                                    pan: false,
                                    reset: false | '<img src="/static/icons/reset.png" width="20">',
                                    customIcons: [],
                                },
                            },
                        },
                        xaxis: { categories: xaxis.sort() },
                        markers: { size: [6] },
                    };
                    console.log(this.series);
                    console.log(this.checkStaff);
                    console.log(this.chartOptions);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        //직원 통계 조회 API
        getStaffStat() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/staff-bill`, {
                params: {
                    startDate: this.yearDate + this.startDate,
                    endDate: this.yearDate + this.endDate,
                    status: this.status,
                },
            });
        },
        signStatus() {
            if (this.sign == true && this.resign == true) {
                this.checkStaff = []; //초기화처리
                return 'T';
            } else if (this.sign == true) {
                this.checkStaff = []; //초기화처리
                return 'I';
            } else if (this.resign == true) {
                this.checkStaff = []; //초기화처리
                return 'O';
            }
        },
    },
};
</script>
<style lang="scss"></style>
